import React from 'react';

import { ChipAnalytics, ChipForGroup } from '@motorway/mw-highway-code/pre-alpha';
import { ChipGroup } from '@motorway/mw-highway-code/src/components/ChipGroup/ChipGroup';

import { POST_SALE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsPostSale';
import { SP_SELLER_COLLECTION_PREFERENCE } from 'Utilities/analytics/analyticsSellerCollectionPreference';

import { DateOption } from '../CollectionPreferences';

import { formatDate } from './DateChipSelect.helpers';

import styles from './DateChipSelect.scss';

export type DateChipSelectProps = {
  blockedDates: string[];
  dateOptions: DateOption;
  defaultValue?: string[];
  limitReached: boolean;
  postSaleAnalytics?: boolean;
  setDateSelections: React.Dispatch<React.SetStateAction<DateOption>>;
}

const DateChipSelect = (
  {
    blockedDates,
    dateOptions,
    defaultValue,
    limitReached,
    postSaleAnalytics = false,
    setDateSelections,
  }: DateChipSelectProps,
) => {
  const chips: ChipForGroup[] = Object.entries(dateOptions).map((option, index) => {
    const [date, selected] = option;

    const isDateBlocked = blockedDates.includes(date);
    const { label, subtext } = formatDate(date) || {};

    return {
      alignment: 'vertical',
      dateIndex: `date_${index + 1}`,
      disabled: isDateBlocked || (limitReached && !selected),
      id: `date_${index + 1}`,
      key: date,
      label,
      selected,
      subtext,
      value: date,
    };
  });

  const handleOnSelect = ({
    chipLastSelectedFromMulti,
  }: ChipAnalytics) => {
    const { id, selected } = chipLastSelectedFromMulti ?? {};

    if (!id || selected === undefined) {
      return;
    }

    if (postSaleAnalytics) {
      POST_SALE_SNOW_PLOW_EVENTS.COLLECTION_PREFERENCES_DATE_CLICKED(selected, id);
    } else {
      SP_SELLER_COLLECTION_PREFERENCE.COLLECTION_PREFERENCES_DATE_CLICKED(selected, id);
    }

    const value = chips.find((chip) => chip.id === id)?.value;
    if (value) {
      setDateSelections((prevState) => ({
        ...prevState,
        [value]: selected,
      }));
    }
  };

  return (
    <div className={styles.dates} data-cy="dateChips" >
      <ChipGroup
        multiple
        asFormResult={false}
        defaultValue={defaultValue}
        getAnalytics={handleOnSelect}
        options={chips}
      />
    </div>);
};

export default DateChipSelect;
